/**
 * Global Lotus AI configuration.
 * This object can injected into the page via ASP.NET.
 * It can be extended from withing .js though.
 */
const config = {
	logoutRootRelativePath: "/logout",
	loginRootRelativePath: "/login",

	forgotPasswordRootRelativePath: "/forgot-password",
	resetPasswordRootRelativePath: "/reset-password",

	defaultPathAfterSuccessfulLogin: "/",

	session: {
		// Signs someone out after a stretch of no activity (see
		// /helpers/useIdleTimeout.js). Off for now - flip to `true` to bring it back.
		idleTimeoutEnabled: false,

		// Absolute cap on how long a signed-in session lasts, regardless of activity.
		// Off by default. Flip this to `true` when a hard session cap is needed;
		// `maxDurationMinutes` controls how long that cap is.
		maxDurationEnabled: false,
		maxDurationMinutes: 480,	// 8 hours
	},

	/**
	 * Every deployment environment the portal knows about, in the order they should be
	 * presented (least production-like first).
	 *
	 * This is the single source of truth for "which environments exist": the environment
	 * detection below (`IsProduction()`, `GetEnvironmentCode()`, ...) reads `portalDomains`
	 * from here rather than carrying its own copy of the domain list, and the System Admin
	 * "API Info" page builds its table from `GetApiEnvironments()`.
	 *
	 * `code` matches the keys in `api.baseUrl` below — adding an
	 * environment means adding an entry here plus its base URL there.
	 */
	environments: [
		{ code: "development", name: "Development (local)", portalDomains: ["localhost", "127.0.0.1"] },
		{ code: "test", name: "Test", portalDomains: ["test.portal.lotusai.co", "lotus-portal-test.netlify.app", "lotus-portal-test2.netlify.app", "lotusai-test-bizfury.netlify.app"] },
		{ code: "testUplift2026", name: "Test (Uplift 2026)", portalDomains: ["lotusai-test-uplift-2026.netlify.app"] },
		{ code: "demo", name: "Demo", portalDomains: ["demo.portal.lotusai.co", "lotus-portal-demo.netlify.app"] },
		{ code: "alpha", name: "Production (Alpha)", portalDomains: ["alpha.portal.lotusai.co", "lotus-portal-production-alpha.netlify.app"] },
		{ code: "production", name: "Production", portalDomains: ["portal.lotusai.co", "lotusai.co"] },
		{ code: "production2", name: "Production (Azure backup portal)", portalDomains: ["nice-pebble-0ed7bac00.6.azurestaticapps.net"] },
	],

	api: {
		baseUrl: {
			development: "https://localhost:7222",		// .NET 9
				//-- So I don't have to run up API in development
				//development: "https://api.lotusai.co",
			

			//test: "https://test.api.lotusai.co",	// Via reverse proxy
			test: "https://lotusai-test-api-2-fue9bzbccahkatbd.australiaeast-01.azurewebsites.net",	// .NET 9


			//testUplift2026: "https://lotusai-test-api.azurewebsites.net",	//TODO: Not sure why I used this API.
			testUplift2026: "https://lotusai-test-api-2-fue9bzbccahkatbd.australiaeast-01.azurewebsites.net",
			

			//production: "https://api.lotusai.co",
			production: "https://lotusai-prod-portal-api-2-bpezeqgfehfte2dp.australiaeast-01.azurewebsites.net",	// .NET 9


			
			production2: "https://api.lotusai.co", // Azure backup portal
			//production2: "https://lotusai-prod-portal-api-2-bpezeqgfehfte2dp.australiaeast-01.azurewebsites.net",	// .NET 9



			//alpha: "https://alpha.api.lotusai.co",
			alpha: "https://lotusai-alpha-api-2-add3decgdrc0hahx.australiaeast-01.azurewebsites.net",	// .NET 9


			demo: "https://lotusai-test-api-2-fue9bzbccahkatbd.australiaeast-01.azurewebsites.net",	// .NET 9
		}
	},




	modules: {
		valenHr: {
			//NOTE: Originally called "Valen HR". Renamed to "Staff HR" for better visibility with potential customers.
			//displayName: "Valen HR"
			displayName: "Staff HR",

			//routePath: "valen-hr",
			routePath: "staff-hr"
		},

		// Keys below match the `meta.module` codes used in the route files.
		admin: {
			displayName: "Administration"
		},

		timesheets: {
			displayName: "Timesheets"
		},

		rostering: {
			displayName: "Rostering"
		},

		myProfile: {
			displayName: "My Profile"
		},
		
		projects: {
			displayName: "Projects"
		},
		
		developers: {
			displayName: "Developers"
		},
		
		resourcing: {
			displayName: "Resource Planning"
		},

		crm: {
			displayName: "Sales & CRM"
		},

		tesstaClients: {
			displayName: "Tessta Client Portal"
		}
	},

	logo: {
		standardFullSizeUrl: "https://lotusai.co/wp-content/uploads/2022/05/logo_white.svg",
		imageOnlyFullSizeUrl: "https://assets.lotusai.co/portal/images/logo-gold-transparent.png",
	},


	/**
	   * Return the base URL to the primary Lotus back-end API for the current envrionment.
	   */
	GetLotusApiBaseUrl()
	{
		const environment = this.GetEnvironmentCode();

		const url = this.api.baseUrl[environment];

		if (environment == "unknown" || url == undefined)
		{
			console.error("Config::GetLotusApiBaseUrl(" + environment + "): Something went wrong. Unknown environment. url=", url);
		} else
		{
			//console.log("Config::GetLotusApiBaseUrl(" + environment + "): url=", url);
			//console.log("Config::GetLotusApiBaseUrl()->getCurrentDomain()=", this.getCurrentDomain());
		}

		return url;
	},

	/**
	   * Look up one environment's definition by its code.
	   *
	   * @param {string} code Environment code (e.g. "production").
	   * @returns object|null The entry from `environments`, or `null` for an unknown code.
	   */
	GetEnvironment(code)
	{
		const environment = this.environments.find((e) => e.code == code);

		return environment ? environment : null;
	},

	/**
	   * Is the portal currently being served from one of this environment's portal domains?
	   *
	   * @param {string} code Environment code (e.g. "production").
	   * @returns bool
	   */
	IsCurrentEnvironment(code)
	{
		const environment = this.GetEnvironment(code);
		if (environment == null) return false;

		return environment.portalDomains.includes(this.getCurrentDomain());
	},

	/**
	   * Check if the current environment is "Production".
	   *
	   * @returns bool
	   */
	IsProduction()
	{
		return this.IsCurrentEnvironment("production");
	},

	// Azure backup production portal
	IsProduction2()
	{
		return this.IsCurrentEnvironment("production2");
	},

	IsProductionAlpha()
	{
		return this.IsCurrentEnvironment("alpha");
	},


	/**
	   * Check if the current environment is "Test".
	   *
	   * @returns bool
	   */
	IsTest()
	{
		return this.IsCurrentEnvironment("test");
	},



	IsTestUplift20206()
	{
		return this.IsCurrentEnvironment("testUplift2026");
	},


	IsDemo()
	{
		return this.IsCurrentEnvironment("demo");
	},

	/**
	   * Check if the current environment is "Development".
	   *
	   * @returns bool
	   */
	IsDevelopment()
	{
		return this.IsCurrentEnvironment("development");
	},

	/**
	   * Return the code for the current environment.
	   *
	   * @returns string Code of the current environment, otherwise "unknown".
	   */
	GetEnvironmentCode()
	{
		const environment = this.environments.find((e) => e.portalDomains.includes(this.getCurrentDomain()));

		return environment ? environment.code : "unknown";
	},

	GetEnvironmentName()
	{
		const environment = this.GetEnvironment(this.GetEnvironmentCode());

		return environment ? environment.name : "unknown";
	},

	/**
	   * Every deployment environment with its resolved API base URLs, for the System Admin
	   * "API Info" page. Presentation order is the declaration order in `environments`.
	   *
	   * @returns {Array} `[{ Code, Name, IsCurrent, ApiBaseUrl, PortalDomains }]`
	   */
	GetApiEnvironments()
	{
		const currentCode = this.GetEnvironmentCode();

		return this.environments.map((environment) => ({
			Code: environment.code,
			Name: environment.name,
			IsCurrent: environment.code == currentCode,
			ApiBaseUrl: this.api.baseUrl[environment.code] ? this.api.baseUrl[environment.code] : "",
			PortalDomains: environment.portalDomains,
		}));
	},

	/**
	   * Return the "domain" component of the URL this site is running on.
	   * 
	   * @returns string
	   */
	getCurrentDomain()
	{
		return window.location.hostname;
	}
};

export default config;
